var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconImage = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.074 8.706a1 1 0 0 1 1.32.091l3.05 3.085 1.956-1.469a1 1 0 0 1 1.211.009l2.579 1.992a1 1 0 1 1-1.223 1.583l-1.976-1.527-2.045 1.535a1 1 0 0 1-1.311-.097L8.592 10.83l-5.466 4.192a1 1 0 0 1-1.217-1.587zM13.5 6a1.5 1.5 0 1 1-.001 3.001A1.5 1.5 0 0 1 13.5 6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.3 1H2.7A1.7 1.7 0 0 0 1 2.7v14.6A1.7 1.7 0 0 0 2.7 19h14.6a1.7 1.7 0 0 0 1.7-1.7V2.7A1.7 1.7 0 0 0 17.3 1M17 3v14H3V3z"
}))));
export default SvgIconImage;